import { createClient, type SupabaseClient } from "@supabase/supabase-js";

const url = import.meta.env.VITE_SUPABASE_URL as string | undefined;
const publishableKey = import.meta.env.VITE_SUPABASE_ANON_KEY as string | undefined;

/**
 * Supabase normally coordinates sign-in between tabs with a browser-wide lock. A tab that gets
 * stuck holding that lock makes every other tab wait forever, so each tab runs on its own.
 */
const noLock = <R,>(_name: string, _acquireTimeout: number, fn: () => Promise<R>): Promise<R> => fn();

/** The Supabase client, or null until the project's URL and publishable key are configured. */
export const supabase: SupabaseClient | null =
  url && publishableKey
    ? createClient(url, publishableKey, {
        auth: {
          persistSession: true,
          autoRefreshToken: true,
          detectSessionInUrl: true,
          storageKey: "peoplecore-auth",
          lock: noLock,
        },
      })
    : null;

export function db(): SupabaseClient {
  if (!supabase) throw new Error("The database connection is not configured.");
  return supabase;
}
